import * as z from "zod";

import { PartnerSummarySchema } from "../shared/partner";

export const impersonationExchange = {
  name: "impersonationExchange" as const,
  input: z.object({ code: z.string().min(1).max(512) }),
  output: z.object({
    partner: PartnerSummarySchema,
    authToken: z.string().min(1),
    expiresAt: z.iso.datetime(),
  }),
};
